import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'credit-card-details',
    templateUrl: './credit.card.details.component.html',
    styleUrls: ['./credit.card.details.component.css']
})
export class CreditCardDetailsComponent implements OnInit {

    IsBusy: boolean = false;

    isEditedTest: boolean = false;

    ngOnInit() {
        this.Init()
    }

    private InitPayMethod() {
        /*
        this.payMethod = [];
        this.payMethod.push({ label: 'Credit Card', value: PaymentMethodTypes.CreditCard });
        this.payMethod.push({ label: 'Cash or Check', value: PaymentMethodTypes.CashOrCheck });
        this.payMethod.push({ label: 'Wire Transfer', value: PaymentMethodTypes.BankTransfer });
        */
    }

    private Init() {
        this.InitPayMethod();
    }

}
